import { useEffect, useContext, useState, forwardRef } from 'react';

import
{
  StyledSectionContainer,
  FirstPlayerContainer,
} from './ClubStats.styles';
import MainWrapper from '../../../../components/Wrappers/MainWrapper/MainWrapper';
import Title from '../../../../components/Typography/Title/Title';

import SectionContainer from '../../../../components/Containers/SectionContainer/SectionContainer';

// Contexts & Helpers
import { BaseContext } from '../../../../providers/Global/BaseProvider';

import { createColorHex } from '../../../../utils/helpers/createColorHex';

import { routes } from '../../../../options/routes';
import { Box, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getClubIdFromParams } from '../../../../utils/helpers/urlHelpers';
import { getAllClubs, getClubLicences, getExpiredClubLicences, getSalesAllClubsCSV, getSalesCSV, getSubscriptions } from '../../../../api';
import ClubDropdownSelector from '../../../../components/StatsPage/ClubDropdownSelector/ClubDropdownSelector';
import axios from 'axios';
import OutlinedButton from '../../../../components/Buttons/OutlinedButton/OutlinedButton';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

const ClubStats = () =>
{
  const params = useParams();
  const baseContext = useContext(BaseContext);
  const [dataLoading, setDataLoading] = useState(false);
  const [clubDataLoading, setClubDataLoading] = useState(false);
  const [clubDropdownOptions, setClubDropdownOptions] = useState([]);
  const [selectedClubId, setSelectedClubId] = useState([]);
  const [allLoaded, setAllLoaded] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [clubs, setClubs] = useState([]);
  const [error, setError] = useState({
    show: false,
    message: '',
  });
  const [clubData, setClubData] = useState(null);
  const [licencesData, setLicencesData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);


  const updateUrl = (clubId, replace = false) =>
  {
    const newUrl = routes.clubStats + `/${clubId}`;
    if (replace)
    {
      window.history.replaceState({}, '', newUrl);
    } else
    {
      window.history.pushState({}, '', newUrl);
    }
  }
  const getClubDropdownOptions = clubs =>
  {
    // Create array of player options to render in select dropdowns
    let options = [];
    // Return empty array if no players
    if (!clubs || clubs.length === 0) return options;

    clubs.forEach(club =>
    {
      const playerName = `${club.firstname} ${club.lastname}`;
      const option = {
        value: club.id,
        id: club.id,
        label: `${club.name} (${club.id})`,
        color: createColorHex(club.id + club.name),

      };
      options.push(option);

    });

    return options;
  };

  useEffect(async () =>
  {
    if (clubs.length === 0)
    {
      const clubList = await getAllClubs();
      setClubs(clubList.data);
      let options = getClubDropdownOptions(clubList.data);
      setClubDropdownOptions(options);

      let clubId = getClubIdFromParams(params);
      if (!clubId)
      {
        const storedClubId = localStorage.getItem('selectedClubId');
        if (storedClubId)
        {
          clubId = JSON.parse(storedClubId);
        }
        else
        {
          clubId = clubList.data[0]?.id;
          localStorage.setItem('selectedClubId', JSON.stringify(clubId));
        }
        updateUrl(clubId, true);

      }
      setSelectedClubId(clubId);
      const newClubData = await getNewClubStats(clubId);
      setClubData(newClubData);

    }
    if (allLoaded)
    {
      setDataLoading(false);

      if (apiError)
      {
        setError({
          show: true,
          message: 'Unable to load some or all page content. Please refresh and try again.'
        });
      }

    }
  }, [baseContext]);

  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: '',
    });
  };

  const handleCSVclick = async () =>
  {
    const data = {
      clubId: selectedClubId,
      token: JSON.parse(localStorage.getItem("token"))
    };
    const filename = `SalesStats-club-${selectedClubId}.csv`
    getSalesCSV(
      data,
      { name: filename },
      () =>
      {
        //    isDownloadingState(false);
      }
    );
  }
  const handleAllCSVclick = async () =>
  {

    const data = {
      token: JSON.parse(localStorage.getItem("token"))
    };
    const filename = `SalesStats-all-clubs.csv`
    getSalesAllClubsCSV(
      data,
      { name: filename },
      () =>
      {
        //    isDownloadingState(false);
      }
    );
  }

  const getNewClubStats = async (clubId) =>
  {
    setAllLoaded(false);
    const url = `stats/sales/${clubId}`;
    try
    {
      const response = await axios({
        method: "GET",
        baseURL: process.env.REACT_APP_API_ENDPOINT,
        url: url,
        params: {},
        data: {},
        headers: {
          "Authorization": JSON.parse(localStorage.getItem("token")),
          "Content-Type": "application/json",
        },
        timeout: 90000,
      });
      const subscriptions = await getSubscriptions(clubId);

      if (subscriptions.success)
      {
        let subArray = [];
        for (const [userId, subRow] of Object.entries(subscriptions.data))
        {

          if (subRow.data.length)
          {
            subArray.push({ userId, data: subRow.data })
            console.log(`stuff ${userId}`, subRow)
          }
        }
        setSubscriptionData(subArray)
      }
      const licences = await getClubLicences(clubId);
      const expiredLicences = await getExpiredClubLicences(clubId);
      console.log('lic', licences, expiredLicences)
      setLicencesData({
        licences: licences.data,
        expired: expiredLicences.data
      })
      setAllLoaded(true);
      return response.data.data;
    }
    catch (error)
    {
      console.log(`Request error from ${url}`);
      console.error(error);
      console.log(error.message);
      setAllLoaded(true);
      return false;
    }

  }

  // Get index of option with matching id
  const getOptionIndex = (id, options) => options.findIndex(el => Number(el.value) === Number(id));

  const getClubData = (id, dropdownOptions) =>
  {
    // Return the player object for the selected id
    const playerIdx = getOptionIndex(id, dropdownOptions);
    return dropdownOptions[playerIdx];
  };

  const getProfileNameById = (id) =>
  {
    let profile = clubData.profiles.find((p) => p.id == id);
    if (profile)
    {
      return `${profile.firstname}  ${profile.lastname}`;
    }
    return `Profile (${id}) not found`;


  }


  const getDrillNameById = (id) =>
  {
    let result = clubData.drills.find((p) => p.id == id);
    if (result)
    {
      return `${result.label}`;
    }
    return `Drill (${id}) not found`;


  }
  const handleClubChange = async e =>
  {
    handleBannerClose();

    // Return if the Please Select option is selected in any dropdown
    const clubId = e.target.value;
    if (!clubId) return;

    setClubDataLoading(true);

    const { id } = baseContext.baseData.userProfile;

    localStorage.setItem('selectedClubId', JSON.stringify(clubId));
    setSelectedClubId(clubId);

    // Make API calls to get player stats data and programme stats data
    const newClubData = await getNewClubStats(clubId);
    setClubData(newClubData);

    updateUrl(clubId);

    setClubDataLoading(false);
  };

  const handleClubReset = () =>
  {
    setClubDataLoading(true);


    setClubDataLoading(false);
  };

  const statHeaderStyle = {
    fontWeight: "bold",
    fontSize: "20px",
    marginTop: "1em"
  };

  const platformtHeaderStyle = {
    fontWeight: "bold",
    fontSize: "16px",
    margin: "2em 2em 0 2em"
  };

  const statContainerStyle = {
    borderBottom: "#444444 1px solid",
    margin: "0.5em 4em"
  };

  const statLabelStyle = {
  };

  const statValueStyle = {
    color: "#F2AF00",
    fontWeight: "bold"
  }

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.clubStats}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={dataLoading}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" justifyContent="flex-start">
              <Title
                text={'Club Stats'}
              />
            </Stack>
            <Stack direction="row" justifyContent="flex-start">
              <OutlinedButton
                text={'Download CSV'}
                onClick={handleCSVclick}
                fullWidth
              />
              <OutlinedButton
                text={'Download All Clubs CSV'}
                onClick={handleAllCSVclick}
                fullWidth
              />
            </Stack>
          </Stack>
          <ClubDropdownSelector
            selected={[selectedClubId]}
            onChange={handleClubChange}
            dropdownOptions={clubDropdownOptions}
            loading={clubDataLoading}
          />

          {clubData ?
            <>
              <StyledSectionContainer>
                {
                  <FirstPlayerContainer addClass="player-container">
                    <SectionContainer>
                      <Typography sx={{ ...statHeaderStyle }}>Daily Active Users</Typography>
                      <Stack direction="row" justifyContent="space-between" sx={{ width: "100%" }}>
                        {clubData.platforms.map((platform) =>
                        {
                          return (
                            <Stack direction="column" sx={{ width: "45%" }}>
                              <Typography sx={{ ...platformtHeaderStyle }}>{platform.label}</Typography>
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Current DAU: </Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {clubData.stats.active_users[platform.id].daily.current}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Previous DAU:</Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {clubData.stats.active_users[platform.id].daily.last}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Average DAU: </Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {Math.floor(clubData.stats.active_users[platform.id].daily.average * 100) / 100}
                                </Typography>
                              </Stack>
                            </Stack>
                          );
                        })}
                      </Stack>
                      <Typography sx={{ ...statHeaderStyle }}>Monthly Active Users</Typography>
                      <Stack direction="row" justifyContent="space-between" sx={{ width: "100%" }}>
                        {clubData.platforms.map((platform) =>
                        {
                          return (
                            <Stack direction="column" sx={{ width: "45%" }}>
                              <Typography sx={{ ...platformtHeaderStyle }}>{platform.label}</Typography>

                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Current MAU: </Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {clubData.stats.active_users[platform.id].monthly.current}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Pervious MAU: </Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {clubData.stats.active_users[platform.id].monthly.last}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>Average MAU: </Typography>
                                <Typography sx={{ ...statValueStyle }}>
                                  {Math.floor(clubData.stats.active_users[platform.id].monthly.average * 100) / 100}
                                </Typography>
                              </Stack>
                            </Stack>
                          );
                        })}
                      </Stack>
                      <Stack direction="row">
                        <Stack direction="column" sx={{ width: "45%" }}>
                          <Typography sx={{ ...statHeaderStyle }}>Profiles</Typography>
                          <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                            <Typography sx={{ ...statLabelStyle }}>Total profiles </Typography>
                            <Typography sx={{ ...statValueStyle }}>{clubData.stats.profile_count}</Typography>
                          </Stack>
                          <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                            <Typography sx={{ ...statLabelStyle }}>Active profiles </Typography>
                            <Typography sx={{ ...statValueStyle }}>{clubData.stats.active_profile_count}</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Stack direction="row" justifyContent="space-between" sx={{ width: "100%" }}>
                        <Stack direction="column" sx={{ width: "45%" }}>
                          <Typography sx={{ ...statHeaderStyle }}>Top Active Profiles (drills played in the last 30 days)</Typography>
                          {clubData.top.profiles.map((profile) =>
                          {
                            return (
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>{getProfileNameById(profile.profile_id)}</Typography>
                                <Typography sx={{ ...statValueStyle }}>{profile.total}</Typography>
                              </Stack >
                            )
                          })
                          }
                        </Stack>
                        <Stack direction="column" sx={{ width: "45%" }}>
                          <Typography sx={{ ...statHeaderStyle }}>Top Played Drills</Typography>
                          {clubData.top.drills.map((drill) =>
                          {
                            return (
                              <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                <Typography sx={{ ...statLabelStyle }}>{getDrillNameById(drill.drill_id)}</Typography>
                                <Typography sx={{ ...statValueStyle }}>{drill.total}</Typography>
                              </Stack >
                            )
                          })
                          }
                        </Stack>
                      </Stack>
                      {/*   <Stack direction="column" sx={{ width: "45%" }}>
                        <Typography sx={{ ...statHeaderStyle }}>Drills played all-time</Typography>
                        {clubData.all.drills.map((drill) =>
                        {
                          return (
                            <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                              <Typography sx={{ ...statLabelStyle }}>{getDrillNameById(drill.drill_id)}</Typography>
                              <Typography sx={{ ...statValueStyle }}>{drill.total}</Typography>
                            </Stack >
                          )
                        })
                        }

                      </Stack> */}
                      <Typography sx={{ ...statHeaderStyle, marginBottom: "0.5em" }}>Club Users</Typography>
                      <Stack direction="row">
                        <Stack direction="column" sx={{
                          width: "100%",
                          height: "20em",
                          overflow: "auto",
                          border: "#444444 1px solid",
                          padding: "0.5em"
                        }}>
                          {clubData.users.map((user) =>
                          {
                            return (
                              <>
                                <Typography sx={{ marginTop: "2em", fontWeight: "bold" }}>
                                  {user.firstname} {user.lastname} {`(${user.email})`}
                                </Typography>
                                <Stack direction="row">
                                  {clubData.platforms.map((platform) =>
                                  {
                                    return (
                                      <Stack direction="column" sx={{ width: "50%" }}>
                                        <Typography sx={{ ...platformtHeaderStyle }}>{platform.label}</Typography>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Logins today: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {user.stats[platform.id].daily.current}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Logins yesterday: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {user.stats[platform.id].daily.last}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Daily login average: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {Math.floor(user.stats[platform.id].daily.average * 100) / 100}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Logins this month: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {user.stats[platform.id].daily.current}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Logins last month: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {user.stats[platform.id].daily.last}
                                          </Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between" sx={{ ...statContainerStyle }}>
                                          <Typography sx={{ ...statLabelStyle }}>Monthly login average: </Typography>
                                          <Typography sx={{ ...statValueStyle }}>
                                            {Math.floor(user.stats[platform.id].daily.average * 100) / 100}
                                          </Typography>
                                        </Stack>
                                      </Stack>
                                    );
                                  })}
                                </Stack>
                              </>
                            );
                          })}
                        </Stack>
                      </Stack>
                    </SectionContainer>
                  </FirstPlayerContainer>
                }
              </StyledSectionContainer>
            </>
            : <></>}
          {clubData ?
            <>
              <StyledSectionContainer>
                {
                  <FirstPlayerContainer addClass="player-container">
                    <SectionContainer>
                      <Typography sx={{ ...statHeaderStyle }}>Licence Information</Typography>
                      <Grid2 container>
                        <Grid2 xs={4}>
                          <Typography sx={{ ...statHeaderStyle }}>Display Name</Typography>
                        </Grid2>
                        <Grid2 xs={3}>
                          <Typography sx={{ ...statHeaderStyle }}>Code</Typography>
                        </Grid2>
                        <Grid2 xs={1}>
                          <Typography sx={{ ...statHeaderStyle }}>Type</Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{ ...statHeaderStyle }}>Expires</Typography>
                        </Grid2>



                        {licencesData.licences.length === 0 &&
                          <Grid2 xs={12}>
                            <Typography sx={{ ...platformtHeaderStyle }}>No licences to display</Typography>
                          </Grid2>
                        }
                        {licencesData.licences.length > 0 && licencesData.licences.map((licence) =>
                        {
                          return (
                            <>
                              <Grid2 xs={4}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.label}</Typography>
                              </Grid2>
                              <Grid2 xs={3}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.code}</Typography>
                              </Grid2>
                              <Grid2 xs={1}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.type}</Typography>
                              </Grid2>
                              <Grid2 xs={4}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.expires}</Typography>
                              </Grid2>
                            </>
                          );
                        })}
                      </Grid2>

                    </SectionContainer>
                  </FirstPlayerContainer>
                }
              </StyledSectionContainer>
            </>
            : <></>}
          {clubData ?
            <>
              <StyledSectionContainer>
                {
                  <FirstPlayerContainer addClass="player-container">
                    <SectionContainer>

                      <Typography sx={{ ...statHeaderStyle }}>Expired Licence Information</Typography>
                      <Grid2 container>
                        <Grid2 xs={4}>
                          <Typography sx={{ ...statHeaderStyle }}>Display Name</Typography>
                        </Grid2>
                        <Grid2 xs={3}>
                          <Typography sx={{ ...statHeaderStyle }}>Code</Typography>
                        </Grid2>
                        <Grid2 xs={1}>
                          <Typography sx={{ ...statHeaderStyle }}>Type</Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{ ...statHeaderStyle }}>Expired</Typography>
                        </Grid2>
                        {licencesData.expired.length === 0 &&
                          <Grid2 xs={12}>
                            <Typography sx={{ ...platformtHeaderStyle }}>No licences to display</Typography>
                          </Grid2>
                        }
                        {licencesData.expired.length > 0 && licencesData.expired.map((licence) =>
                        {
                          return (
                            <>
                              <Grid2 xs={4}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.label}</Typography>
                              </Grid2>
                              <Grid2 xs={3}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.code}</Typography>
                              </Grid2>
                              <Grid2 xs={1}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.type}</Typography>
                              </Grid2>
                              <Grid2 xs={4}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.expires}</Typography>
                              </Grid2>
                            </>
                          );
                        })}
                      </Grid2>
                    </SectionContainer>
                  </FirstPlayerContainer>
                }
              </StyledSectionContainer>
            </>
            : <></>}
          {clubData ?
            <>
              <StyledSectionContainer>
                {
                  <FirstPlayerContainer addClass="player-container">
                    <SectionContainer>

                      <Typography sx={{ ...statHeaderStyle }}>Stripe Subscription Information</Typography>

                      <Grid2 container>
                        <Grid2 xs={2}>
                          <Typography sx={{ ...statLabelStyle }}>License Type</Typography>
                        </Grid2>
                        <Grid2 xs={2}>
                          <Typography sx={{ ...statLabelStyle }}>Object Type</Typography>
                        </Grid2>
                        <Grid2 xs={1}>
                          <Typography sx={{ ...statLabelStyle }}>Period Start</Typography>
                        </Grid2>
                        <Grid2 xs={1}>
                          <Typography sx={{ ...statLabelStyle }}>Period End</Typography>
                        </Grid2>
                        <Grid2 xs={1}>
                          <Typography sx={{ ...statLabelStyle }}>Status</Typography>
                        </Grid2>
                        <Grid2 xs={5}>
                          <Typography sx={{ ...statLabelStyle }}>Raw data</Typography>
                        </Grid2>
                        {subscriptionData.length === 0 &&
                          <Grid2 xs={12}>
                            <Typography sx={{ ...platformtHeaderStyle }}>No Subscription data to display</Typography>
                          </Grid2>
                        }
                        {subscriptionData.length && subscriptionData[0].data.length && subscriptionData[0].data.map((licence) =>
                        {
                          return (
                            <>
                              <Grid2 xs={2}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.items.data[0].plan.metadata.license_type}</Typography>
                              </Grid2>
                              <Grid2 xs={2}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.object}</Typography>
                              </Grid2>
                              <Grid2 xs={1}>
                                <Typography sx={{ ...statLabelStyle }}>{Date(licence.current_period_start)}</Typography>
                              </Grid2>
                              <Grid2 xs={1}>
                                <Typography sx={{ ...statLabelStyle }}>{Date(licence.current_period_end)}</Typography>
                              </Grid2>
                              <Grid2 xs={1}>
                                <Typography sx={{ ...statLabelStyle }}>{licence.status}</Typography>
                              </Grid2>
                              <Grid2 xs={5}>
                                <Box
                                  sx={{
                                    overflow: 'auto',
                                    fontSize: '1em',
                                    maxHeight: 300,
                                  }}
                                >
                                  <pre>{JSON.stringify(licence, null, 2)}</pre>
                                </Box>
                              </Grid2>
                            </>
                          );
                        })}
                      </Grid2>
                    </SectionContainer>
                  </FirstPlayerContainer>
                }
              </StyledSectionContainer>
            </>
            : <></>}
        </MainWrapper >
      }
    </>
  );
};

export default ClubStats;
